module.exports = __webpack_public_path__ + "img/Value2_s.00fe623e.png";